<template>
  <div class="badge-container">
    <span :class="['status-badge', getFillTypeClass(normalizedFillType)]">
      {{ normalizedFillType }}
      <span
        v-if="showIcon || computedTooltipText"
        class="icon-container"
        @mouseenter.stop="showTooltip = true"
        @mouseleave.stop="showTooltip = false"
        ref="iconRef"
        :style="{ '--svg-color': getComputedColor() }"
      >
        <SvgIcon name="info" class="info-icon" />
      </span>
    </span>

    <InfoTagPopup
      v-if="showTooltip && (showIcon || computedTooltipText)"
      :message="computedTooltipText"
      :position="tooltipPosition"
      :triggerRef="$refs.iconRef"
      :style="{ 'pointer-events': 'none' }"
      @close="showTooltip = false"
    />
  </div>
</template>

<script>
import SvgIcon from "@/components/ui/svg/SvgIcon.vue";
import InfoTagPopup from "@/components/ui/dataTable/InfoTagPopup.vue";

export default {
  name: "FillTypeCell",
  components: {
    SvgIcon,
    InfoTagPopup,
  },

  props: {
    fillType: {
      type: String,
      required: true,
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
    tooltipText: {
      type: String,
      default: "",
    },
    tooltipPosition: {
      type: String,
      default: "top",
    },
  },

  data() {
    return {
      showTooltip: false,
    };
  },

  computed: {
    normalizedFillType() {
      // Si c'est une valeur technique, on la traduit
      if (this.fillType === "auto") return this.$t('collections.fillType.auto');
      if (this.fillType === "manual") return this.$t('collections.fillType.manual');
      
      // Conversion pour s'assurer d'avoir la forme correcte (anciennes valeurs)
      if (this.fillType === "Manuel") return "Manuelle";
      if (this.fillType === "Auto") return "Automatique";
      return this.fillType;
    },
    computedTooltipText() {
      return this.tooltipText || this.getDefaultTooltip(this.fillType);
    }
  },

  methods: {
    getFillTypeClass(type) {
      const fillTypeMap = {
        // Nouvelles valeurs techniques
        "auto": "fill-type--auto",
        "manual": "fill-type--manual",
        // Anciennes valeurs françaises
        "Automatique": "fill-type--auto",
        "Manuelle": "fill-type--manual",
        "Manuel": "fill-type--manual",
        // Valeurs traduites en anglais
        "Automatic": "fill-type--auto",
        "Manual": "fill-type--manual"
      };

      return fillTypeMap[type] || "";
    },

    getDefaultTooltip(type) {
      const tooltips = {
        // Nouvelles valeurs techniques
        "auto": this.$t("collections.fillType.auto_tooltip"),
        "manual": this.$t("collections.fillType.manual_tooltip"),
        // Anciennes valeurs françaises
        "Automatique": this.$t("collections.fillType.auto_tooltip"),
        "Manuelle": this.$t("collections.fillType.manual_tooltip"),
        "Manuel": this.$t("collections.fillType.manual_tooltip"),
        // Valeurs traduites en anglais
        "Automatic": this.$t("collections.fillType.auto_tooltip"),
        "Manual": this.$t("collections.fillType.manual_tooltip")
      };

      return tooltips[type] || "";
    },
    toggleTooltip() {
      this.showTooltip = !this.showTooltip;
    },
    getComputedColor() {
      return "currentColor";
    },
  },
};
</script>

<style scoped>
.badge-container {
  position: relative;
  display: inline-block;
}

.status-badge {
  position: relative;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  border: 1px solid;
}

.icon-container {
  display: inline-flex;
  margin-left: 6px;
  cursor: help;
  --svg-color: currentColor;
}

.info-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 14px;
  height: 14px;
  min-width: 14px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.3);
  font-size: 10px;
}

.fill-type--auto {
  background-color: #f3f3ff;
  color: #4346DE;
  border-color: #4346DE;
}

.fill-type--manual {
  background-color: #FFF3FF;
  color: #B32CB3;
  border-color: #B32CB3;
}
</style>
